import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private sessionTimeUpdated = new Subject<void>();

  sessionTimeUpdated$ = this.sessionTimeUpdated.asObservable();

  notifySessionTimeUpdated() {
    this.sessionTimeUpdated.next();
  }
}
